import { useRoom } from '@hook'
import { yupResolver } from '@hookform/resolvers/yup'
import { roomSchema } from '@schema'
import { useAppSelector } from '@store/hooks'
import { FormButton, FormInputField, Modal, SelectInputField } from '@ui'
import { getError, showToast } from '@util'
import { Box, Form } from 'grommet'
import { FormProvider, useForm } from 'react-hook-form'
import useFormPersist from 'react-hook-form-persist'
import { useParams } from 'react-router-dom'
import { InferType } from 'yup'

type Props = {
  onClose: () => void
  unitId?: string
}
export const AddRoom = ({ onClose, unitId }: Props) => {
  const { detail } = useParams()
  const roomTypes = useAppSelector(state => state.config.room_types)
  const { addRoom } = useRoom({ id: detail || unitId || '' })
  const methods = useForm({ resolver: yupResolver(roomSchema) })

  const {
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { isSubmitting }
  } = methods

  const { clear } = useFormPersist('addRoom', { setValue, storage: window.localStorage, watch })

  const handleClose = () => {
    onClose()
    reset()
    clear()
  }

  const onSubmit = async ({ ...rest }: InferType<typeof roomSchema>) => {
    const formRecObj = {
      data: {
        attributes: {
          ...rest
        },
        relationships: {
          unit: {
            data: {
              id: detail || unitId,
              type: 'units'
            }
          }
        },
        type: 'room'
      }
    }
    try {
      await addRoom(formRecObj)
      handleClose()
      showToast('Room added successfully')
    } catch (error: any) {
      getError(error)
    }
  }
  return (
    <FormProvider {...methods}>
      <Modal onClose={handleClose} title="Add Room">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Box overflow="auto" pad={{ horizontal: '32px', vertical: '16px' }} width={'530px'}>
            <Box className="mx-auto w-full max-w-[399px]" flex={false} gap={'20px'}>
              <Box
                flex={false}
                gap={'20px'}
                overflow="auto"
                pad={{ horizontal: '32px', vertical: '16px' }}
                style={{ minWidth: 'min(440px, calc(100vw - 1.5rem))' }}
              >
                <Box pad="0">
                  <FormInputField label="Number" name="room_number" placeholder="" />
                </Box>
                <Box pad="0">
                  <SelectInputField
                    dropProps={{
                      align: { left: 'left', right: 'right', top: 'bottom' }
                    }}
                    label="Type"
                    labelKey={'name'}
                    name="room_type"
                    options={roomTypes}
                    placeholder="Select Type"
                    valueKey={{ key: 'value', reduce: true }}
                  />
                </Box>
                <Box pad="0">
                  <FormInputField label="Amount" name="price" placeholder="" type="number" />
                </Box>
              </Box>
            </Box>
          </Box>
          <FormButton isLoading={isSubmitting} onClose={handleClose} />
        </Form>
      </Modal>
    </FormProvider>
  )
}
